import { render } from "./BaseCheckBox.vue?vue&type=template&id=230913c3&scoped=true"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"

import "./BaseCheckBox.vue?vue&type=style&index=0&id=230913c3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-230913c3"

export default script